import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssistantIcon from '@mui/icons-material/Assistant';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import BadgeIcon from '@mui/icons-material/Badge';
import BarChartIcon from '@mui/icons-material/BarChart';
import BiotechIcon from '@mui/icons-material/Biotech';
import BuildIcon from '@mui/icons-material/Build';
import BusinessIcon from '@mui/icons-material/Business';
import CalculateIcon from '@mui/icons-material/Calculate';
import CategoryIcon from '@mui/icons-material/Category';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import CodeIcon from '@mui/icons-material/Code';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FolderIcon from '@mui/icons-material/Folder';
import HandshakeIcon from '@mui/icons-material/Handshake';
import InventoryIcon from '@mui/icons-material/Inventory';
import KitchenIcon from '@mui/icons-material/Kitchen';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LoopIcon from '@mui/icons-material/Loop';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TerminalIcon from '@mui/icons-material/Terminal';
import UpdateIcon from '@mui/icons-material/Update';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import _ from 'lodash';

import { useEffect, useMemo, useState } from 'react';
import { tenantSettingsService } from 'shared/services';
import {
  ROLE_SUPER_ADMIN,
  ROLE_TENANT_ADMIN,
  ROLE_TENANT_DIRECTOR,
  ROLE_TENANT_SUPPLIER,
  ROLE_TENANT_TECHNICIAN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR
} from 'shared/permissions/roles';
import Menu from './Menu';
import { ITenantSettings } from 'features/settings/tenant-settings/types';

interface TenantMenuProps {
  collapsed: boolean;
}

export const SidebarNavigation = ({ collapsed }: TenantMenuProps) => {
  const [metabaseTabs, setMetabaseTabs] = useState<any[]>([]);

  // Caricamento asincrono dei dati
  useEffect(() => {
    tenantSettingsService
      .get(1)
      .then((res: ITenantSettings) => {
        localStorage.setItem('MINIAVA_ENABLED', JSON.stringify(res.miniava_active ?? false));
        if (res?.metabase_dashboard_tabs) {
          const dynamicTabs = res.metabase_dashboard_tabs
            .split(',')
            .filter((tabName) => tabName.trim() !== '')
            .map((tabName) => ({
              name: tabName,
              href: _.kebabCase(tabName),
              icon: SummarizeIcon,
              roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
              translate: false,
              contexts: ['REFERTING']
            }));

          setMetabaseTabs(dynamicTabs);
        }
      })
      .catch(() => {
        // Silently fail
      });
  }, []);

  const navigationConfig = useMemo(() => {
    const nav: any[] = [];

    nav.push({
      name: 'home',
      href: 'home',
      icon: DashboardIcon,
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_DIRECTOR
      ]
    });

    {
      /*ANAGRAFICA*/
    }
    nav.push({
      name: 'registry',
      icon: FolderIcon,
      contexts: ['LAB'],
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_DIRECTOR,
        ROLE_TENANT_SUPPLIER
      ],
      children: [
        {
          name: 'contracts',
          href: 'contracts',
          icon: HandshakeIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_SUPPLIER],
          contexts: ['LAB']
        },
        {
          name: 'suppliers',
          href: 'suppliers',
          icon: StorefrontIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'products',
          href: 'products',
          icon: BiotechIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'warehouses',
          href: 'warehouses',
          icon: StoreIcon,
          contexts: ['LAB'],
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN
          ]
        },
        {
          name: 'locations',
          href: 'locations',
          icon: KitchenIcon,
          contexts: ['LAB'],
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN
          ]
        },
        {
          name: 'skus',
          href: 'skus',
          icon: QrCode2Icon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN
          ],
          contexts: ['LAB']
        },
        {
          name: 'custom-reports',
          href: 'custom-reports',
          icon: BackupTableIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_DIRECTOR
          ],
          contexts: ['LAB']
        }
      ]
    });

    {
      /* GESTIONE ASSET */
    }
    nav.push({
      name: 'asset_management',
      icon: AssistantIcon,
      contexts: ['LAB'],
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_DIRECTOR,
        ROLE_TENANT_SUPPLIER
      ],
      children: [
        {
          name: 'equipments',
          href: 'equipments',
          end: true,
          icon: PrecisionManufacturingIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'accessories',
          href: 'equipments/accessories',
          icon: BuildIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR
          ],
          contexts: ['LAB']
        },
        {
          name: 'maintenance',
          href: 'equipments/maintenance',
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          icon: EngineeringIcon,
          contexts: ['LAB']
        },
        {
          name: 'ticketing',
          href: 'equipments/ticketing',
          icon: ConfirmationNumberIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'equipment-invoices',
          href: 'equipments/invoices',
          icon: ReceiptIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['LAB']
        },
        {
          name: 'checklist',
          href: 'equipments/checklist',
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR
          ],
          icon: AssignmentIcon,
          contexts: ['LAB']
        }
      ]
    });

    {
      /*INVENTARIO*/
    }
    nav.push({
      name: 'inventory',
      icon: ViewModuleIcon,
      contexts: ['LAB'],
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_SUPPLIER,
        ROLE_TENANT_DIRECTOR
      ],
      children: [
        {
          name: 'movements',
          href: 'movements',
          icon: CompareArrowsIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN
          ],
          contexts: ['LAB']
        },
        {
          name: 'stock',
          href: 'stock',
          icon: ShowChartIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_SUPPLIER,
            ROLE_TENANT_DIRECTOR
          ],
          contexts: ['LAB']
        },
        {
          name: 'inventory-check',
          href: 'inventory-check',
          icon: ChecklistRtlIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR
          ],
          contexts: ['LAB']
        },
        {
          name: 'consumption',
          href: 'consumption',
          icon: LeaderboardIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        }
      ]
    });

    {
      /*ACQUISTI*/
    }
    nav.push({
      name: 'purchase',
      icon: ShoppingCartIcon,
      contexts: ['LAB'],
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_DIRECTOR,
        ROLE_TENANT_SUPPLIER
      ],
      children: [
        {
          name: 'purchase-requests',
          href: 'purchase_requests',
          icon: ViewListIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR
          ],
          contexts: ['LAB']
        },
        {
          name: 'orders',
          href: 'orders',
          icon: LocalShippingIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'ddt',
          href: 'ddt',
          icon: ListAltIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_SUPPLIER
          ],
          contexts: ['LAB']
        },
        {
          name: 'invoices',
          href: 'invoices',
          icon: LocalAtmIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['LAB']
        },
        {
          name: 'active-ddt',
          href: 'active-ddt',
          icon: AltRouteIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR
          ],
          contexts: ['LAB']
        },
        {
          name: 'supplier-active-ddt',
          href: 'supplier-active-ddt',
          icon: LoopIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_TECHNICIAN_COORDINATOR,
            ROLE_TENANT_TECHNICIAN,
            ROLE_TENANT_DIRECTOR
          ],
          contexts: ['LAB']
        }
      ]
    });

    // -------------------------------------- EVALUATE --------------------------------------

    {
      /*CLINICA*/
    }
    nav.push({
      name: 'clinic',
      icon: VaccinesIcon,
      contexts: ['EVALUATE'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
      children: [
        {
          name: 'categories',
          href: 'categories',
          icon: CategoryIcon,
          contexts: ['EVALUATE'],
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN]
        },
        {
          name: 'exams',
          href: 'cost-analysis/exams',
          icon: MonitorHeartIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
          contexts: ['EVALUATE', 'REFERTING']
        },
        {
          name: 'medical-services',
          href: 'medical-services',
          icon: MedicalServicesIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
          contexts: ['EVALUATE', 'REFERTING']
        },
        {
          name: 'workstations',
          href: 'cost-analysis/workstations',
          icon: WarehouseIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        }
      ]
    });

    {
      /*COSTI*/
    }
    nav.push({
      name: 'const',
      icon: AccountBalanceWalletIcon,
      contexts: ['EVALUATE'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
      children: [
        {
          name: 'cost-analysis',
          href: 'cost-analysis',
          icon: CalculateIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        },
        {
          name: 'cost-analysis-reports',
          href: 'cost-analysis/reports',
          icon: QueryStatsIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        },
        {
          name: 'costs',
          href: 'cost-analysis/costs',
          icon: PointOfSaleIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        },
        {
          name: 'regional-rates',
          href: 'cost-analysis/regional-rates',
          icon: RequestQuoteIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE', 'REFERTING']
        }
      ]
    });

    {
      /*TEAM*/
    }
    nav.push({
      name: 'team',
      icon: PeopleAltIcon,
      contexts: ['EVALUATE'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
      children: [
        {
          name: 'role-names',
          href: 'staff-management/role-names',
          icon: BadgeIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        },
        {
          name: 'expertises',
          href: 'staff-management/expertises',
          icon: AssignmentIndIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        },
        {
          name: 'activities',
          href: 'staff-management/activities',
          icon: WorkHistoryIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['EVALUATE']
        }
      ]
    });

    // -------------------------------------- REFERTING --------------------------------------

    {
      /*ATTIVITÀ CLINICA*/
    }
    nav.push({
      name: 'clinical-activity',
      icon: MedicalInformationIcon,
      contexts: ['REFERTING'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
      children: [
        {
          name: 'exams',
          href: 'cost-analysis/exams',
          icon: MonitorHeartIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
          contexts: ['REFERTING']
        },
        {
          name: 'medical-services',
          href: 'medical-services',
          icon: MedicalServicesIcon,
          end: true,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR],
          contexts: ['REFERTING']
        },
        {
          name: 'regional-rates',
          href: 'cost-analysis/regional-rates',
          icon: RequestQuoteIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['REFERTING']
        }
      ]
    });

    {
      /*REPORTISTICA SPECIFICA Specifica */
    }
    nav.push({
      name: 'specific-reporting',
      icon: BarChartIcon,
      contexts: ['REFERTING'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN, ROLE_TENANT_DIRECTOR, ROLE_TENANT_TECHNICIAN],
      children: [
        {
          name: 'reporting',
          href: 'reporting',
          icon: SummarizeIcon,
          roles: [
            ROLE_SUPER_ADMIN,
            ROLE_TENANT_ADMIN,
            ROLE_TENANT_DIRECTOR,
            ROLE_TENANT_TECHNICIAN
          ],
          contexts: ['REFERTING']
        },
        ...metabaseTabs
      ]
    });

    // -------------------------------------- SETTINGS --------------------------------------

    {
      /*SISTEMA*/
    }
    nav.push({
      name: 'system',
      icon: ManageAccountsIcon,
      contexts: ['SETTINGS'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
      children: [
        {
          name: 'users',
          href: 'users',
          icon: PeopleAltIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'types',
          href: 'types',
          icon: CategoryIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'structure',
          href: 'topology',
          icon: BusinessIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'versions',
          href: 'versions',
          icon: UpdateIcon,
          roles: [ROLE_SUPER_ADMIN], //, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'history',
          href: 'history',
          icon: HistoryEduIcon,
          roles: [ROLE_SUPER_ADMIN], //, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'settings',
          href: 'settings',
          icon: SettingsIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        }
      ]
    });

    {
      /*TRANSCODIFICHE*/
    }
    nav.push({
      name: 'transcodes',
      icon: TerminalIcon,
      contexts: ['SETTINGS'],
      roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
      children: [
        {
          name: 'lis-transcodes',
          href: 'lis-transcodes',
          icon: CodeIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'department-transcodes',
          href: 'department-transcodes',
          icon: MultipleStopIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        },
        {
          name: 'extra-field-transcode',
          href: 'extra-field-transcode',
          icon: SwapHorizIcon,
          roles: [ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN],
          contexts: ['SETTINGS']
        }
      ]
    });

    nav.push({
      name: 'documents',
      href: 'documents',
      icon: InventoryIcon,
      contexts: ['LAB'],
      roles: [
        ROLE_SUPER_ADMIN,
        ROLE_TENANT_ADMIN,
        ROLE_TENANT_TECHNICIAN_COORDINATOR,
        ROLE_TENANT_TECHNICIAN,
        ROLE_TENANT_DIRECTOR
      ]
    });

    return nav;
  }, [[metabaseTabs]]);

  return Menu(navigationConfig, collapsed);
};

export default SidebarNavigation;
